/**
 * Returns the path if it is a safe relative path (starts with '/' but not '//',
 * and contains no protocol like 'javascript:'). Falls back to fallback otherwise.
 * Use this to sanitize user-controlled redirect destinations.
 */
export const safeRelativeRedirect = (path: string, fallback = '/'): string => {
    if (path.startsWith('/') && !path.startsWith('//') && !path.includes(':')) {
        return path;
    }
    return fallback;
};

export const toNullable = (str: string): string | null => {
    if (str.trim() === '') {
        return null;
    }
    return str;
};
export const toPascalCase = (str: string): string => {
    // First, insert spaces between lowercase and uppercase letters (for camelCase, PascalCase, etc)
    let normalized = str.replace(/([a-z])([A-Z])/g, '$1 $2');

    // Then, replace non-word separators with spaces
    normalized = normalized.replace(/[_\- ]+/g, ' ');

    // Split by spaces, lowercase everything, then capitalize first letter of each word
    const words = normalized
        .split(' ')
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());

    return words.join('');
};

// TODO: This doesn't handle all cases correctly, specifically words that shouldn't
// be capitalized, and letters after abbreviations, like in the name "Jo-Ann".
export const toTitleCase = (str: string): string => {
    const lowercased = str.toLowerCase();
    return lowercased
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};
